/**
 * Barre d'onglets — EF-NAV-006.
 *
 * Fixe en bas de l'écran : c'est la seule bande qu'un pouce atteint sans
 * lâcher le cintre. Elle porte à gauche le bouton d'actions, permanent et
 * explicitement libellé — jamais un bouton « … ».
 */

import type { JSX } from 'preact';
import { Glyph } from '../icons';
import { SCREENS } from '../labels';
import { openSheet, screen } from '../state';

export function TabBar(): JSX.Element {
  const active = screen.value;

  return (
    <nav class="tab-bar" role="tablist" aria-label="Écrans de l’application">
      <button
        type="button"
        class="tab-bar__menu"
        aria-label="Actions"
        onClick={() => {
          openSheet('actions');
        }}
      >
        <Glyph name="actions" label="" size={24} decorative />
      </button>

      <Tab name="setup" label={SCREENS.setup} active={active === 'setup'} />
      <Tab name="roadbook" label={SCREENS.roadbook} active={active === 'roadbook'} />
    </nav>
  );
}

function Tab(props: {
  readonly name: 'setup' | 'roadbook';
  readonly label: string;
  readonly active: boolean;
}): JSX.Element {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={props.active}
      // L'onglet actif se distingue par le fond, l'épaisseur du trait et le
      // poids du libellé, jamais par la seule couleur.
      class={props.active ? 'tab-bar__tab tab-bar__tab--active' : 'tab-bar__tab'}
      onClick={() => {
        screen.value = props.name;
      }}
    >
      {props.label}
    </button>
  );
}
